import {
  SwapiServiceProvider,
  SwapiServiceConsumer
} from './swapi-service-context';

export {
  SwapiServiceProvider,
  SwapiServiceConsumer
};



// WEBPACK FOOTER //
// ./src/components/swapi-service-context/index.js